import React, { useEffect, useState } from 'react';
import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { useSelector } from "react-redux";
import moment from "moment";
import { postFormulaire } from "../../../api/envoiMailService";
import { checkInvalidDateEffet, renderError } from "../../../utils/formUtils";
import { postChangementContrat } from "../../../api/modificationContratService";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";
const CONF = window?.confPub;

export default function ChangementGarantie(
    {
        isInside
    }
) {

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        infosCorrespondant,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const initDisplayMessage = {
        success: false,
        failure: false,
    }

    const PATTERNS = CONF?.PATTERNS
    const UI = CONF?.UI
    const UI_DATE_EFFET = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.DATE_EFFET
    const [disabledForm, setDisabledForm] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })

    const [dateEffet, setDateEffet] = useState({
        name: UI_DATE_EFFET?.NAME,
        value: "",
        invalid: UI_DATE_EFFET?.ERRORS?.MANDATORY,
    })
    const [produitSelected, setProduitSelected] = useState()
    const [produitSenorSelected, setProduitSenorSelected] = useState()

    const listeProduitsSante = UI?.FORMULAIRES?.LISTE_PRODUITS?.PRODUITS_SANTE
    const listeProduitsSenorSante = UI?.FORMULAIRES?.LISTE_PRODUITS?.PRODUITS_SENOR_SANTE

    const handleOptionChange = (e) => {

        const value = e?.target?.value
        const name = e?.target?.name

        if (name === "produitSenor") {

            const produitSenor = listeProduitsSenorSante?.find(({code}) => code === value)
            setProduitSenorSelected(produitSenor?.code ?? "")

        } else {
            const produit = listeProduitsSante?.find(({code}) => code === value)

            setProduitSelected(produit?.code ?? "")
        }
    }

    const handleDateEffet = (e) => {

        dateEffetValidation(e.target.value);
    }

    const dateEffetValidation = (value) => {
        const invalid = checkInvalidDateEffet(value, PATTERNS?.YYYY_DASH_MM_DASH_DD)

        setDateEffet((prev) => ({
            ...prev,
            value: value,
            invalid: invalid,
        }))

        return invalid
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        setDisabledForm(true);

        const validDateEffet = !checkInvalidDateEffet(dateEffet?.value)

        if (validDateEffet && ((produitSelected && produitSelected !== "RETRAITE") || (produitSelected === "RETRAITE" && produitSenorSelected))) {

            const formToSend = {
                idGrm: keycloakReduce?.decodedToken?.idGrm,
                idGrcDemandeur: infosCorrespondant?.idGrc,
                idGrcBeneficiaire: detailPersonne?.idPersGrc,
                codeDomaine: contrat?.gammeContrat,
                codeQualification: CODES_FORMULAIRES?.CHANGEMENT_GARANTIE,
                champ: [
                    {
                        label: "Date d'effet",
                        valeur: moment(dateEffet?.value, PATTERNS?.YYYY_DASH_MM_DASH_DD).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY)
                    },

                    ...(produitSelected === "RETRAITE" ? [
                        {
                            label: "Nouvelle garantie retraite souhaitée",
                            valeur: listeProduitsSenorSante?.find(({code}) => code === produitSenorSelected)?.label
                        },
                        {
                            label: "Code produit retraite associé",
                            valeur: produitSenorSelected
                        },
                    ] : [
                        {
                            label: "Nouvelle garantie souhaitée",
                            valeur: listeProduitsSante?.find(({code}) => code === produitSelected)?.label
                        },
                        {
                            label: "Code produit associé",
                            valeur: produitSelected
                        },
                    ]),
                ],
            }

            try {

                const resp = await postChangementContrat(formToSend)

                setSendSuccess({
                    isSuccess: !!resp?.data?.idGrcDemande,
                    message: false,
                    display: true,
                })

                erasedInputs(false)

            } catch (err) {

                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })

                setSubmitted(true);

            } finally {

                setDisabledForm(false)
            }

        } else {
            setDisabledForm(false)
            setSubmitted(true);
        }
    }

    const erasedInputs = (all) => {

        setSubmitted(false)

        setProduitSelected("")
        setProduitSenorSelected("")

        setDateEffet((prev) => ({
            ...prev,
            value: "",
        }))

        if (all) {

            setSendSuccess({
                isSuccess: false,
                message: false,
                display: false,
            })
        }
    }

    return (
        <div className="container mt-3">
            { !isInside && <SecondaryNavBar /> }
            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>
                    <div className="card">

                        <form onSubmit={ handleSubmit }>
                            <div className="card-header">
                                <h2>Changement de garantie</h2>
                            </div>

                            <div className="card-body">

                                <div className="mt-2 col-lg-4">
                                    <label className='form-label'
                                        htmlFor="dateEffet">
                                        Date d'effet :
                                    </label>
                                    <input
                                        id="dateEffet"
                                        className="form-control"
                                        value={ dateEffet?.value }
                                        onChange={ handleDateEffet }
                                        type="date"/>

                                    { submitted && dateEffet?.invalid
                                        && renderError(dateEffet?.invalid) }
                                </div>

                                <div className='mt-3'>
                                    <div className='form-label'>
                                        Choisir une garantie souhaitée :
                                    </div>
                                    { listeProduitsSante?.length > 0 && listeProduitsSante.map(produit => (
                                        <div className="form-check" key={ produit?.code }>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="produit"
                                                value={ produit?.code }
                                                checked={ produitSelected === produit?.code }
                                                id={ produit?.code }
                                                onChange={ handleOptionChange }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ produit?.code }>
                                                { produit?.label }
                                            </label>
                                        </div>
                                    )) }

                                    { submitted && !produitSelected
                                        && renderError("Vous devez choisir un produit") }
                                </div>

                                { produitSelected === "RETRAITE" && (
                                    <div className="mt-3">

                                        <div className='form-label'>
                                            Vous pouvez vous orienter vers un produit retraite :
                                        </div>

                                        { listeProduitsSenorSante?.length > 0 && listeProduitsSenorSante.map((produitSenor) => (
                                            <div className="form-check" key={ produitSenor?.code }>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="produitSenor"
                                                    value={ produitSenor?.code }
                                                    checked={ produitSenorSelected === produitSenor?.code }
                                                    id={ produitSenor?.code }
                                                    onChange={ handleOptionChange }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={ produitSenor?.code }>
                                                    { produitSenor?.label }
                                                </label>
                                            </div>
                                        )) }

                                        { submitted && !produitSenorSelected
                                            && renderError("Vous devez choisir un produit") }
                                    </div>
                                ) }

                                <MessageInfoEnvoi
                                    isSuccess={ sendSuccess?.isSuccess }
                                    message={ sendSuccess?.message }
                                    display={ sendSuccess?.display }
                                />
                            </div>

                            <div className="card-footer">
                            <div className='d-flex justify-content-end'>
                                    <button
                                        type='submit'
                                        className="btn btn-primary"
                                    >
                                        Envoyer
                                    </button>
                                    <button
                                        type='button'
                                        onClick={ ()  => erasedInputs(true)}
                                        className="btn btn-secondary ms-2"
                                    >
                                        Effacer
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}